import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "queued-export-modal__message" }

import Button from 'primevue/button';
import AppModal from '@/components/ui/AppModal.vue';

interface Props {
    visible: boolean
    title: string
    message: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QueuedExportModal',
  props: {
    visible: { type: Boolean },
    title: {},
    message: {}
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */


const emit = __emit;

function close(): void {
    emit('update:visible', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    visible: __props.visible,
    title: __props.title,
    width: "520px",
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', $event)))
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        type: "button",
        label: "Close",
        class: "queued-export-modal__close-btn",
        onClick: close
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.message), 1)
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})